import React, { useRef } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { useHistory } from "react-router-dom";
const TopRecipes = ({ receipes }) => {
  const history = useHistory();
  let imageGallery = useRef(null);
  const images = receipes.map((ele) => ({
    original: ele.data.image,
    thumbnail: ele.data.image,
    thumbnailWidth: 50,
    thumbnailHeight: 50,
  }));
  const gotoPage = () => {
    history.push(`/receipe/${receipes[imageGallery.getCurrentIndex()].id}`);
  };
  return (
    <div style={{ margin: "20px 0" }}>
      <ImageGallery
        ref={(i) => (imageGallery = i)}
        showBullets={true}
        onClick={gotoPage}
        showNav={false}
        showFullscreenButton={false}
        swipingTransitionDuration={1}
        showIndex={true}
        items={images}
        autoPlay={true}
        sizes={400}
        showPlayButton={false}
        _renderCustomControls={() => <a href="/">dsfads</a>}
      />
    </div>
  );
};

export default TopRecipes;
